import { combineReducers } from 'redux';
import { LOCATION_CHANGE } from 'react-router-redux';

import event from './event';
import camera from './camera';
import playerSrc from './playerSrc';
import analytics from './analytics';
import donation from './donation';

const routeInitialState = {
  locationBeforeTransitions: null,
};

function rootReducer(state = routeInitialState, action) {
  switch (action.type) {
    /* istanbul ignore next */
    case LOCATION_CHANGE:
      return {
        locationBeforeTransitions: action.payload,
      };
    default:
      return state;
  }
}
export default function createReducer() {
  return combineReducers({
    routing: rootReducer,
    event,
    camera,
    playerSrc,
    analytics,
    donation,
  });
}
